import apiConfig from '../../config/api_config';

export const adminApi = {
    // Dashboard statistics
    getDashboardStats: () => apiConfig.get('/admins/dashboard_stats/'),
    
    // Pending approvals
    getPendingApprovals: () => apiConfig.get('/admins/pending_approvals/'),
    
    // Recent activities
    getRecentActivities: () => apiConfig.get('/admins/recent_activities/'),
    
    // Doctor approval actions
    approveDoctor: (doctorId) => apiConfig.post(`/doctors/${doctorId}/approve/`),
    rejectDoctor: (doctorId) => apiConfig.post(`/doctors/${doctorId}/reject/`),
    
    // Laboratory approval actions  
    approveLab: (labId) => apiConfig.post(`/laboratories/${labId}/approve/`),
    rejectLab: (labId) => apiConfig.post(`/laboratories/${labId}/reject/`),
    
    // Vendor approval actions
    approveVendor: (vendorId) => apiConfig.post(`/vendors/${vendorId}/approve/`),
    rejectVendor: (vendorId) => apiConfig.post(`/vendors/${vendorId}/reject/`),
};
